<section id="capabilities" class="capabilities-section">
    <div class="container-xl">
      <h2 class="section-title" data-animation="fade-in-up">Our Capabilities</h2>

      <!-- Horizontal continuously scrolling banner -->
      <div class="capabilities-slider" data-animation="fade-in-up" data-animation-delay="1">
        <div class="slider-container">
          <div class="slider-track" #sliderTrack>
            <div
              *ngFor="let capability of capabilities"
              class="capability-card {{capability.bgClass}}-card"
              [ngClass]="{'active': isActive(capability)}"
              (click)="selectCapability(capability)">
              <div class="card-content">
                <div class="icon-container" [style.background-color]="capability.iconBgColor">
                  <i class="fas {{capability.icon}}"></i>
                </div>
                <div class="card-text">
                  <h5>{{capability.title}}</h5>
                  <p class="desc-text">{{capability.description}}</p>
                </div>
              </div>
            </div>
            <!-- Duplicate items for infinite scrolling effect -->
            <div
              *ngFor="let capability of capabilities"
              class="capability-card duplicate-card {{capability.bgClass}}-card"
              [ngClass]="{'active': isActive(capability)}"
              (click)="selectCapability(capability)">
              <div class="card-content">
                <div class="icon-container" [style.background-color]="capability.iconBgColor">
                  <i class="fas {{capability.icon}}"></i>
                </div>
                <div class="card-text">
                  <h5>{{capability.title}}</h5>
                  <p class="desc-text">{{capability.description}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Indicator dots for mobile -->
        <div class="slider-dots d-md-none">
          <span *ngFor="let capability of capabilities; let i = index"
                class="dot"
                [ngClass]="{'active': isActive(capability)}"
                (click)="selectCapability(capability)"></span>
        </div>
      </div>

      <!-- Capability details section -->
      <div class="capability-details" [ngClass]="{'visible': isDetailVisible}" *ngIf="activeCapability">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-5">
              <div class="detail-content">
                <span class="badge badge-primary mb-3" data-animation="fade-in-up">{{activeCapability.title}}</span>
                <p class="detail-description" data-animation="fade-in-up" data-animation-delay="1">{{activeCapability.detailedDescription}}</p>

                <div class="features-list" data-animation="fade-in-up" data-animation-delay="2">
                  <div class="feature-item" *ngFor="let feature of activeCapability.features; let i = index"
                       [attr.data-animation]="'fade-in-left'"
                       [attr.data-animation-delay]="i + 1">
                    <div class="feature-icon">
                      <i class="fas fa-check"></i>
                    </div>
                    <div class="feature-text">
                      <h6>{{feature.title}}</h6>
                      <p>{{feature.description}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-7">
              <div class="detail-visual {{activeCapability.bgClass}}" data-animation="fade-in-right" data-animation-delay="1">
                <!-- Display capability image -->
                <img [src]="activeCapability.imageUrl" alt="{{activeCapability.title}}" class="capability-image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
